import {
  searchCriteria,
  purposes,
  sizeModels,
  planningPeriods,
  planningYears,
  classCodes,
  subClassCodes,
  flowLongDescriptions,
  ssns,
  distros,
  gisAgents,
  gisAgentCodes,
  coos,
  inStoreDates,
  brandCodes,
  divisionCodes,
  departmentCodes,
  categoryCodes,
  subCategoryCodes,
  itemTypes,
  productTypes,
  linePlans,
  shipToAttns,
  deactivatedPurposes,
  deactivatedAdSampleTypes,
  sampleMarkets,
  plmSampleTypes,
  marketCodes,
  seasonalWorkspace,
  productTeam,
  requestPurpose,
  rawMaterialType,
  materialAction,
  smrStatus,
  smrSearchParamsCache,
  devSearchParamsCache,
  cocCatalogs,
  svdOffice,
  gauge,
  end,
  roundNum,
  cocSubCategory,
  keyCostDriver,
  cocFabric,
  age,
  gender,
  smrOrderingTimeliness,
  flowNames,
  orderingTimelinesss
} from './definition'

const sortByName = (list) => {
  return list.sort((a, b) => {
    if (a.name < b.name) {
      return -1
    } else if (a.name > b.name) {
      return 1
    } else {
      return 0
    }
  })
}

export default {
  [searchCriteria] (state, { field, value }) {
    state.smsSearchCriteria[field] = value
  },
  [purposes] (state, value) {
    state.purposes = sortByName(value)
  },
  [shipToAttns] (state, value) {
    state.shipToAttns = value
  },
  [sizeModels] (state, value) {
    state.sizeModels = sortByName(value)
  },
  [planningPeriods] (state, value) {
    state.planningPeriods = sortByName(value)
  },
  [planningYears] (state, value) {
    state.planningYears = sortByName(value)
  },
  [classCodes] (state, value) {
    state.classCodes = sortByName(value)
  },
  [subClassCodes] (state, value) {
    state.subClassCodes = sortByName(value)
  },
  [itemTypes] (state, value) {
    state.itemTypes = value
  },
  [productTypes] (state, value) {
    state.productTypes = value
  },
  [flowLongDescriptions] (state, value) {
    state.flowLongDescriptions = sortByName(value)
  },
  [ssns] (state, value) {
    state.ssns = sortByName(value)
  },
  [distros] (state, value) {
    state.distros = sortByName(value)
  },
  [gisAgents] (state, value) {
    state.gisAgents = sortByName(value)
  },
  [gisAgentCodes] (state, value) {
    state.gisAgentCodes = sortByName(value)
  },
  [coos] (state, value) {
    state.coos = value
  },
  [inStoreDates] (state, value) {
    state.inStoreDates = sortByName(value)
  },
  [brandCodes] (state, value) {
    state.brandCodes = sortByName(value)
  },
  [divisionCodes] (state, value) {
    state.divisionCodes = sortByName(value)
  },
  [departmentCodes] (state, value) {
    state.departmentCodes = sortByName(value)
  },
  [categoryCodes] (state, value) {
    state.categoryCodes = sortByName(value)
  },
  [subCategoryCodes] (state, value) {
    state.subCategoryCodes = sortByName(value)
  },
  [linePlans] (state, value) {
    state.linePlans = sortByName(value)
  },
  [deactivatedPurposes] (state, value) {
    state.deactivatedPurposes = sortByName(value)
  },
  [deactivatedAdSampleTypes] (state, value) {
    state.deactivatedAdSampleTypes = sortByName(value)
  },
  [sampleMarkets] (state, value) {
    state.sampleMarkets = sortByName(value)
  },
  [plmSampleTypes] (state, value) {
    state.plmSampleTypes = value
  },
  [marketCodes] (state, value) {
    state.marketCodes = value
  },
  [seasonalWorkspace] (state, value) {
    state.seasonalWorkspace = value
  },
  [productTeam] (state, value) {
    state.productTeam = value
  },
  [requestPurpose] (state, value) {
    state.requestPurpose = value
  },
  [rawMaterialType] (state, value) {
    state.rawMaterialType = value
  },
  [materialAction] (state, value) {
    state.materialAction = value
  },
  [smrStatus] (state, value) {
    state.smrStatus = value
  },
  [smrSearchParamsCache] (state, value) {
    state.smrSearchParamsCache = value
  },
  [devSearchParamsCache] (state, value) {
    state.devSearchParamsCache = value
  },
  [cocCatalogs] (state, value) {
    state.cocCatalogs = sortByName(value)
  },
  [svdOffice] (state, value) {
    state.svdOffice = sortByName(value)
  },
  [gauge] (state, value) {
    state.gauge = sortByName(value)
  },
  [end] (state, value) {
    state.end = sortByName(value)
  },
  [roundNum] (state, value) {
    state.roundNum = sortByName(value)
  },
  [cocSubCategory] (state, value) {
    state.cocSubCategory = sortByName(value)
  },
  [keyCostDriver] (state, value) {
    state.keyCostDriver = sortByName(value)
  },
  [cocFabric] (state, value) {
    state.cocFabric = sortByName(value)
  },
  [age] (state, value) {
    state.age = sortByName(value)
  },
  [gender] (state, value) {
    state.gender = sortByName(value)
  },
  [smrOrderingTimeliness] (state, value) {
    state.smrOrderingTimeliness = sortByName(value)
  },
  [flowNames] (state, value) {
    state.flowNames = sortByName(value)
  },
  [orderingTimelinesss] (state, value) {
    state.orderingTimelinesss = sortByName(value)
  }
}



// WEBPACK FOOTER //
// ./src/components/samplemanagement/common/store/mutations.js